import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@mui/material';
import { CrisisAlertOutlined, Circle } from '@mui/icons-material';
import _ from 'lodash';

const colors = ['#4caf50', '#ec407a', '#9c27b0'];

const CustomGraphDot = ({ cx, cy, value, stroke }) => {
  const { t } = useTranslation();

  const layer = _.indexOf(colors, stroke);
  const dotHeight = layer * 25;

  if (value === null) {
    return (
      <Tooltip title={t('out_of_range') + ' - ' + (layer + 1) * 6 + '"'} style={{ width: 25, height: 25 }}>
        <CrisisAlertOutlined
          x={cx - 10}
          y={cy + 55 + dotHeight}
          width={20}
          height={20}
          sx={{ color: stroke, zIndex: 1500 }}
        />
      </Tooltip>
    );
  }

  return value > 0 && <Circle x={cx - 4.5} y={cy - 4.5} width={9} height={9} sx={{ color: stroke }} />;
};

CustomGraphDot.propTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  stroke: PropTypes.string,
  payload: PropTypes.object,
  value: PropTypes.number,
};

CustomGraphDot.defaultProps = {
  cx: 0,
  cy: 0,
  stroke: '#000',
  payload: {},
  value: 0,
};

export default CustomGraphDot;
